import {h, render} from 'preact';
import Modernizr from 'modernizr';
import $ from '@modules/jquery-import';
import mediaQuery from '@util/media-queries';
import namespace from '../../upi/namespace';
import {jqueryContentToggle, jquerySmartResize, Corpus, Waypoints} from '@modules/lazy-imports';
import Provider from 'preact-context-provider';
import {client} from '@core/GraphQLProvider';
import CustomerReviews from '@containers/CustomerReviews';
import PageNavigation from '@components/common/PageNavigation';

function makeToggleable( {selector, showCount} ) {
    const $list = $( selector );

    if ( $list.length > showCount ) {
        const contentSet = $list.eq( showCount - 1 ).nextAll();
        contentSet.toContentToggle( {
            label: upi.i18n.getTextFromKey( 'lbl-viewMore', 'View more' )
        } );
    }
}

var app = namespace( 'apps.productpage' ),

    PageController = Backbone.View.extend( {

        el: '#body-content',

        nodes: {
            '$productFamilyOverview': '#productFamilyOverview',
            '$customerReviews': '#customer-reviews-container',
            '$contentSections': '.product-content-section',
            '$productImageWrapper': '#productImageWrapper'
        },

        initNodes() {
            var nodes = this.nodes;
            for ( var node in nodes ) {
                if ( nodes.hasOwnProperty( node ) ) {
                    nodes[node] = this.$el.find( nodes[node] );
                }
            }
        },

        initialize() {
            // page initialization
            this.currentBreakPoint = mediaQuery.getCurrentBreakPoint();
            let anchorId = location.hash;

            this.initPageNav();
            this.initNodes();
            this.initCustomerReviews();
            this.initCarousels( this.nodes.$contentSections );

            if ( Modernizr.mq( mediaQuery.max['screenMedium'] ) ) {
                this.applyContentToggles();
                this.applyMediaEmbeds();
            }
        },

        async initCarousels( scope ) {
            await Corpus();
            this.configureCarousels( scope );

            await jquerySmartResize();
            $( window ).smartresize( () => {
                var bp = mediaQuery.getCurrentBreakPoint();
                if ( bp !== this.currentBreakPoint ) {
                    scope.corpus( 'off' );
                    this.configureCarousels( scope );
                    this.currentBreakPoint = bp;
                }
            } );
        },

        configureCarousels( scope ) {
            const {mq} = Modernizr;
            const opts = {multiplier: 2};

            if ( mq( mediaQuery.min.screenBase ) || !mq( 'only all' ) ) {
                opts.multiplier = 5;
            }
            else if ( mq( mediaQuery.min.screenLarge ) ) {
                opts.multiplier = 4;
            }
            else if ( mq( mediaQuery.min.screenMedium ) ) {
                opts.multiplier = 3;
            }

            scope.corpus( 'carousel', opts );
        },

        applyMediaEmbeds() {
            // set embed target for video containers
            this.nodes.$productFamilyOverview.find( '.videos a[href*="http://www.youtube.com"]' ).each( function () {
                this.setAttribute( 'data-embed-target', 'img-ratio-16x9' );
            } );
        },

        async applyContentToggles() {
            await jqueryContentToggle();

            $( '#footnotes' ).toContentToggle( {
                label: upi.i18n.getTextFromKey( 'lbl-seeFootnotes', 'See Footnotes' )
            } );

            makeToggleable( {
                selector: '#productFeatures [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productTechnicalDetails [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productSpecs [data-list-item]',
                showCount: 5
            } );
            makeToggleable( {
                selector: '#productClinicals [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productVideos [data-list-item]',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productFAQs [data-list-item]',
                showCount: 3
            } );

            $( '#productProcedures [data-list="procedure"]' ).each( function () {
                makeToggleable( {
                    selector: $( this ).find( '[data-list-item]' ),
                    showCount: 1
                } );
            } );

            makeToggleable( {
                selector: '#productTestimonials [data-list="testimonial-videos"] article',
                showCount: 1
            } );
            makeToggleable( {
                selector: '#productTestimonials [data-list="testimonial-comments"] article',
                showCount: 2
            } );
        },

        initPageNav() {
            const ATTR_NAV_ITEM = 'data-inline-nav-item';
            let navList = document.querySelectorAll( `[${ATTR_NAV_ITEM}]` );

            if ( navList.length ) {
                const nodeList = Array.from( navList ).map( node => {
                    return {
                        el: node,
                        id: node.getAttribute( 'name' ),
                        label: node.getAttribute( ATTR_NAV_ITEM )
                    };
                } );

                var headerMain = document.querySelector( '#header--main' );
                render( <PageNavigation nodeList={nodeList}/>, headerMain );
            }
        },

        initCustomerReviews() {
            // Customer Reviews
            if ( this.nodes.$customerReviews ) {
                render(
                    <Provider client={client}>
                        <CustomerReviews/>
                    </Provider>,
                    null,
                    this.nodes.$customerReviews[0] );
            }
            else {
                console.warn(
                    'Could not mount <CustomerReviewQuery /> component; Root node #customer-reviews-container not found' )
            }
        }

    } );

export default PageController;
